module.exports = __webpack_public_path__ + "img/QR.6becae4b.jpg";